<template>
  <div>
    <el-form
      :model="addForm"
      label-width="120px"
      :rules="addFormRules"
      ref="addRuleForm"
      auto-complete="off"
      style="overflow-x: hidden; overflow-y: hidden; margin-right: 4%"
      :disabled="loadCarInfodisabled"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="客户" prop="orgID">
            <el-select
              v-model="addForm.orgID"
              style="width: 100%"
              placeholder="客户"
            >
          <el-option
            v-for="item in organizationList"
            :label="item.customName"
            :value="item.organizationId"
            :key="item.organizationId"
          ></el-option>

            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="参考单号" prop="orgOutboundNo">
            <el-input
              v-model="addForm.orgOutboundNo"
              auto-complete="off"
              placeholder="请输入参考单号"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- :disabled="editdisbled" -->

      </el-row>

       <el-row>
        <el-col :span="12">
          <el-form-item label="发货仓" prop="outWarehouseCode">
            <el-select
              v-model="addForm.outWarehouseCode"
              style="width: 100%"
              placeholder="发货仓"
            >
              <el-option
            v-for="item in WareHouse"
            :label="item.warehouseName"
            :value="item.warehouseCode"
            :key="item.warehouseCode"
          ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- :disabled="editdisbled" -->
        <el-col :span="12">
          <el-form-item label="运输方式" prop="transportType">
            <el-select
              v-model="addForm.transportType"
              style="width: 100%"
              placeholder="运输方式"
              @change="GetContainerNumber"
            >
              <el-option
                v-for="item in transportList"
                :label="item.transportTypeText"
                :value="item.transportTypeText"
                :key="item.transportTypeId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

<el-row>
        <el-col :span="12">
          <el-form-item label="SO号" prop="soNumber">
            <el-input
              v-model="addForm.soNumber"
              auto-complete="off"
              placeholder="请输入SO号"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="柜号">
            <el-input
              v-model="addForm.containerNumber"
              auto-complete="off"
              placeholder="请输入柜号"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- :disabled="editdisbled" -->

      </el-row>
      <el-row>
        <el-col :span="12">
           <el-form-item label="预计发货" prop="deliveryDate">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="addForm.deliveryDate"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="车牌">
            <el-input
              v-model="addForm.carNumber"
              auto-complete="off"
              placeholder="请输入车牌"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- :disabled="editdisbled" -->

      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="司机" >
             <el-input
              v-model="addForm.driver"
              auto-complete="off"
              placeholder="请输入司机"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="电话">
            <el-input
              v-model="addForm.driverPhone"
              auto-complete="off"
              placeholder="请输入电话"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- :disabled="editdisbled" -->

      </el-row>
      <el-row v-if="loadCarInfoType == 1">
        <el-form-item label="">
          <!--<el-button type="primary" plain @click="getBoxMarkDetailed"
            >选择入库批次</el-button
          >-->
          <el-button type="primary" plain @click="exportBox"
            >导出模板</el-button
          >
           <el-button type="primary" plain @click="importBox"
            >导入</el-button
          >
           <el-button type="primary" plain @click="showAddDialog"
            >新增</el-button
          >
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="">
          <div class="otherTable">
            <el-table-bar :fixed="true" :bottom="35">
              <el-table border :data="tableData" style="width: 100%">
                <el-table-column
                  prop="orgCustomerNo"
                  label="参考单号"
                  min-width="90"
                  align="center"
                >
                 </el-table-column>
                   <el-table-column
                  prop="boxCount"
                  label="发货箱数"
                  min-width="90"
                  align="center"
                  class-name="col-bg"
                >
                 </el-table-column>
                 <el-table-column
                  prop="inBoxCount"
                  label="在库箱数"
                  min-width="90"
                  align="center"
                >
                </el-table-column>
                  <el-table-column
                  prop="pickStatusText"
                  label="状态"
                  min-width="90"
                  align="center"
                >
                </el-table-column>

                <el-table-column
                  label="操作"
                  min-width="100"
                  align="center"
                  fixed="right"
                  v-if="loadCarInfoType == 1"
                >
                    <template slot-scope="scope">
                    <el-button
                      @click="delboxMark(scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                    <el-button v-if="scope.row.inBoxCount > 0 && scope.row.inBoxCount<scope.row.boxCount"
                      @click="selInBox(scope.row)"
                      type="text"
                      size="small"
                      >选择在库</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-table-bar>
            <div class="block">
              <el-pagination layout="total" :total="total" style="float: right">
              </el-pagination>
            </div>
          </div>
        </el-form-item>
      </el-row>
      <el-row
        type="flex"
        class="row-bg"
        justify="center"
        v-if="loadCarInfoType == 1"
      >
        <el-button type="primary" @click="onAddSubmit" :loading="addLoading"
          >提交</el-button
        >
      </el-row>
    </el-form>

    <!-- 装车明细数据 -->
    <el-dialog
      :visible.sync="shippingVisible"
      v-model="boxMarkVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="出库信息"
      width="90%"
      top="50px"
      style="text-align: center"
    >
      <div style="width: 100%; text-align: left; margin-bottom: 10px">
        <el-button type="primary" @click="onAddShippingPlan" style=""
          >确认</el-button
        >
      </div>
      <el-table
        :data="shippingdata"
        highlight-current-row
        border
        style="width: 100%"
        height="400"
        @row-click="handleCellClick"
        @selection-change="selsChange"
        ref="multipleTable"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          prop="orgCustomerNo"
          label="参考单号"
          align="center"
          sortable
        >
        </el-table-column>

        <el-table-column prop="boxCount" label="箱数" sortable align="center">
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 上传发货信息 -->
    <el-dialog
      :visible.sync="importVisible"
      v-model="importVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="上传出库信息"
      width="40%"
      style="text-align: center"
    >
      <el-form>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload
              ref="upload"
              class="upload-demo"
              drag
              action="string"
              :http-request="UploadExcel"
              :limit="1"
              accept=".xls,.xlsx"
              :before-upload="onBeforeUploadExcel"
              :auto-upload="false"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传.xls,.xlsx文件
              </div>
            </el-upload>
          </el-form-item>
        </el-row>
        <!-- 上传显示进度条 -->
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item>
          </el-form-item>
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="submitUpload"
              >确认上传</el-button
            >
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <div v-show="progressFlag" class="head-img" style="width: 150px">
            <el-progress
              :text-inside="true"
              :percentage="progressPercent"
              status="success"
            ></el-progress>
          </div>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <div style="color: red"> {{ Importtext }}</div>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 新增参考单号对话框 -->
    <el-dialog
      :visible.sync="addDialogVisible"
      title="新增"
      width="20%"
    >
      <el-form :label-position="'left'" label-width="80px" style="margin-bottom: 10px">
        <el-form-item label="参考单号">
          <el-input
            v-model="addDialogForm.orgCustomerNo"
            auto-complete="off"
            placeholder="请输入参考单号"
            maxlength="50"
            style="width: 100%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center; padding-top: 5px">
        <el-button @click="addDialogCancel">取消</el-button>
        <el-button type="primary" @click="addDialogSubmit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style>
.el-input.is-disabled .el-input__inner {
  background-color: rgb(255, 251, 251) !important;
  color: rgb(12, 12, 12) !important;

}
</style>
<script>
import { getReadyforTaskBasis } from "@/api/outbound/readyforTask.js";
import {
  getStockingBoxSumByStockingTaskID,
  GetStockingBoxListByStockingTaskID,
  getSholeStockingBoxSum,
} from "@/api/outbound/loadingOrder.js";
import axios from "axios";
import {
  getTFTemporaryStorage,
  addTFOuntboundOrder,
  getOutboundInfoByID,
  exportTFOutOrder,
  importTFOutDeliveryOrder,
  addTFOutDeliveryOrder,
  getInStockBoxInfo
} from "@/api/outbound/outboundOrder.js";
export default {
  data() {
    return {
      addForm: {
        TFOutboundID: 0,
        outWarehouseCode: "",
        transportType: "",
        orgOutboundNo: "",
        deliveryDate: "",
        containerNumber: "",
        sealNumber: "",
        soNumber: "",
        cabinetType: "",
        carNumber: "",
        driver: "",
        driverPhone: "",
      },
      addFormRules: {
        orgID: [
          { required: true, message: "请选择客户", trigger: "change" },
        ],
        outWarehouseCode: [
          { required: true, message: "请选择仓库", trigger: "change" },
        ],
        transportType: [
          { required: true, message: "请选择运输方式", trigger: "change" },
        ],
        orgOutboundNo: [
          { required: true, message: "请输入参考单号", trigger: "blur" },
        ],
        soNumber: [
          { required: true, message: "请输入SO号", trigger: "blur" },
        ],
        deliveryDate: [
          { required: true, message: "请选择预计发货日期", trigger: "change" },
        ],
      },
      choiceForm: {
        start: "",
        end: "",
      },
      WareHouse: [],
      transportList: [],
      addLoading: false,
      tableData: [],
      Importtext: "",
      total: 0,
      progressFlag:false,
      progressPercent:0,
      boxMarkdata: [],
      boxMarkVisible: false,
      CabinetTypeList: [],
      shippingSels: [],
      NumberVisible: false,
      shippingdata: [],
      importVisible:false,
      shippingVisible: false,
      boxNoList: [],
      boxNoSels: [],
      editdisbled: false,
      loadCarInfoType: 1,
      loadCarInfodisabled: false,
      organizationList: [],
      addDialogVisible: false,
      addDialogForm: {
        orgCustomerNo: ''
      },
    };
  },
  methods: {
    scoreCellStyle() {
      // 直接返回背景颜色（整列统一颜色）
      return { backgroundColor: '#fde9d9' }
      // 也可以写字符串形式
      // return 'background-color: #fde9d9;'
    },
    handleCellClick(row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    selsChange(sels) {
      this.shippingSels = sels;
    },
    boxNoselsChange(sels) {
      this.boxNoSels = sels;
    },
    onAddNoNeed() {
      let start = this.choiceForm.start;
      let end = this.choiceForm.end;
      let regcarNumber =/^[1-9]\d*$/;
      if (start === "") {
        this.$message({
          message: "起始箱号不能为空！",
          type: "error",
        });
        return;
      }
      if (end === "") {
        this.$message({
          message: "结束箱号不能为空！",
          type: "error",
        });
        return;
      }
      if (!regcarNumber.test(start)||!regcarNumber.test(end)) {
              this.$message({
              message: "箱号只能输入正整数！",
              type: "error",
              });
              return;
        }
      if (parseInt(start) > parseInt(end)) {
        this.$message({
          message: "起始箱号不能大于结束箱号！",
          type: "error",
        });
        return;
      }
      let that = this;
      this.$nextTick(function () {
        for (let i = parseInt(start); i <= parseInt(end); i++) {
          for (let j = 0; j < this.boxMarkdata.length; j++) {
            if (
              this.boxMarkdata[j].boxNo != "" &&
              i === parseInt(this.boxMarkdata[j].boxNo)
            ) {
              that.$refs.multipleboxMarkTable.toggleRowSelection(
                this.boxMarkdata[j],
                false
              );
              break;
            }
          }
        }
      });
       this.choiceForm.start="";
       this.choiceForm.end="";
    },
    onAddNotIssued() {
       let start = this.choiceForm.start;
      let end = this.choiceForm.end;
      let regcarNumber =/^[1-9]\d*$/;
      if (start === "") {
        this.$message({
          message: "起始箱号不能为空！",
          type: "error",
        });
        return;
      }
      if (end === "") {
        this.$message({
          message: "结束箱号不能为空！",
          type: "error",
        });
        return;
      }
      if (!regcarNumber.test(start)||!regcarNumber.test(end)) {
              this.$message({
              message: "箱号只能输入正整数！",
              type: "error",
              });
              return;
        }
      if (parseInt(start) > parseInt(end)) {
        this.$message({
          message: "起始箱号不能大于结束箱号！",
          type: "error",
        });
        return;
      }

      let that = this;
      this.$nextTick(function () {
        for (let i = parseInt(start); i <= parseInt(end); i++) {
          for (let j = 0; j < this.boxMarkdata.length; j++) {
            if (
              this.boxMarkdata[j].boxNo != "" &&
              i === parseInt(this.boxMarkdata[j].boxNo)
            ) {
              this.boxMarkdata[j].statusBool = false;
              that.$refs.multipleboxMarkTable.toggleRowSelection(
                this.boxMarkdata[j],
                true
              );
              break;
            }
          }
        }
      });
      this.choiceForm.start="";
      this.choiceForm.end="";
    },

    exportBox() {
      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      const data = {
        tfOutboundID: this.addForm.tfOutboundID,
      };
      axios
        .get(exportTFOutOrder, {
          params: data,
        })
        .then((res) => {
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    importBox() {
      var orgId = this.addForm.orgID;
      if (orgId == "" || orgId == null) {
        this.$message({
          message: "请选择客户",
          type: "error",
        });
        return;
      }
      const that = this;
      this.Importtext = "";
      this.importVisible = true;

    },
     onBeforeUploadExcel(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      if (!extension && !extension2) {
        this.$message({
          message: "导入文件只能是 xls、xlsx格式!",
          type: "error",
        });
      }
      return extension || extension2;
    },
    submitUpload() {
      var orgId = this.addForm.orgID;
      if (orgId == "" || orgId == null) {
        this.$message({
          message: "请选择客户",
          type: "error",
        });
        return;
      }

      this.$refs.upload.submit();
    },

     UploadExcel(param) {
      if (param == undefined) {
        this.$message({
          message: "请上传导入文件",
          type: "error",
        });
        return;
      }

      this.parafile = param;
      let para = new FormData();
      para.append("file", param.file);
      var orgId = this.addForm.orgID;
      this.progressFlag = true;
      axios({
        url: importTFOutDeliveryOrder + "?tfOutboundID=" + (this.addForm.tfOutboundID|| 0)+ "&orgId=" + orgId,
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          this.type = 1;
          this.Importtext = res.data.msg;
          if (res.data.success) {
             this.tableData = res.data.response;
              this.parafile = "";
              param.onError();
              this.importVisible = false;
              if(res.data.response.length>0){
                  this.tableData=res.data.response;
                  this.isShowScanNoSend=true;
              }
              else
              {
                this.isShowScanNoSend=false;
              }

              this.$message({
                message: res.data.msg,
                type: "success",
              });


          } else {

              this.$message({
                message: res.data.msg,
                type: "error",
              });
              param.onError();

          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          param.onError();
        });
    },


    GetContainerNumber() {
      if (this.addForm.transportType == "海运") {
        this.NumberVisible = true;
      } else {
        this.NumberVisible = false;
      }
    },
    GetWarehouse() {
      this.tableData = [];
      this.boxNoList = [];
      this.total = this.tableData.length;
    },
    getBoxMarkDetailed() {
      var orgId = this.addForm.orgID;
      var warehouseCode = this.addForm.outWarehouseCode;
      if (orgId == "" || orgId == null) {
        this.$message({
          message: "请选择客户",
          type: "error",
        });
        return;
      }
      if (warehouseCode == "" || warehouseCode == null) {
        this.$message({
          message: "请选择仓库",
          type: "error",
        });
        return;
      }

      let pata = {
        warehouseCode: warehouseCode,
        orgId: orgId
      };
      this.shippingdata = [];
      this.shippingVisible = true;
      getTFTemporaryStorage(pata).then((res) => {
        if (res.data.success) {
          this.shippingdata = res.data.response;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },

    onAddShippingPlan() {
      var shippingData = this.shippingSels;
      if (shippingData == null || shippingData.length == 0) {
        this.$message({
          message: "至少选择一行数据！",
          type: "error",
        });
        return;
      }
      var arr = [];
      this.shippingVisible = false;
      this.tableData=shippingData;
    },

    delboxMark(row) {
      this.$confirm("确认删除[" + row.orgCustomerNo + "]吗?", "提示", {}).then(() => {
        const index = this.tableData.findIndex(
          (item) =>
            item.tfDeliveryOrderID === row.tfDeliveryOrderID
        );
        if (index > -1) {
          this.tableData.splice(index, 1);

          this.total = this.tableData.length;
          for (var i = 0; i < this.boxNoList.length; i++) {
            const delindex = this.boxNoList.findIndex(
              (item) =>
                item.tfDeliveryOrderID === row.tfDeliveryOrderID
            );
            if (delindex > -1) {
              this.boxNoList.splice(delindex, 1);
              i--;
            } else break;
          }
          this.$message({
            message: "已删除，需提交后更新",
            type: "success",
          });
        } else {
          this.$message({
            message: "删除失败",
            type: "error",
          });
        }
      });
    },

    selInBox(row) {
      this.$confirm(row.orgCustomerNo+",确认发货[" + row.inBoxCount + "]箱吗?", "提示", {}).then(() => {
        const operatorRow = this.tableData.find(
          (item) =>
            item.tfDeliveryOrderID === row.tfDeliveryOrderID
        );
        if (operatorRow!=undefined) { 
          var query = this.$route.query;
          let pata = {
        tfDeliveryOrderID: row.tfDeliveryOrderID,
        tfOutboundID: query.tfOutboundID
      };
          getInStockBoxInfo(pata).then((res) => {
          if (res.data.success) {
            operatorRow.boxCount=row.inBoxCount;
            operatorRow.boxIDs=res.data.response[0].boxIDs;
            this.$message({
              message: "已刷新，需提交后更新",
              type: "success",
            });
          }
          else {
            this.$message({
              message: "操作失败",
              type: "error",
            });
          }
          });
        } 
      });
    },
    onAddBoxMark() {
      var boxNoData = this.boxNoSels;
      if (boxNoData == null || boxNoData.length == 0) {
        this.$message({
          message: "至少选择一行数据！",
          type: "error",
        });
        return;
      }

      var stockingTaskID = boxNoData[0].stockingTaskID;
      var shippingPlanDetailID = boxNoData[0].shippingPlanDetailID;
      var stockingBoxSumID = boxNoData[0].stockingBoxSumID;
      let pata = {
        stockingTaskID: stockingTaskID,
        shippingPlanDetailID: shippingPlanDetailID,
        stockingBoxSumID: stockingBoxSumID,
        boxList: boxNoData.map((item) => item.stockingBoxListID).join(","),
        loadCarInfoID: this.addForm.LoadCarInfoID,
      };

      getStockingBoxSumByStockingTaskID(pata).then((res) => {
        if (res.data.success) {
          this.boxMarkVisible = false;
          for (var i = 0; i < this.boxNoList.length; i++) {
            const delindextable = this.tableData.findIndex(
              (item) =>
                item.shippingPlanDetailID === shippingPlanDetailID &&
                item.stockingBoxSumID === stockingBoxSumID
            );
            if (delindextable > -1) {
              this.tableData.splice(delindextable, 1);
            }

            const delindex = this.boxNoList.findIndex(
              (item) =>
                item.shippingPlanDetailID === shippingPlanDetailID &&
                item.stockingBoxSumID === stockingBoxSumID
            );
            if (delindex > -1) {
              this.boxNoList.splice(delindex, 1);
              i--;
            } else break;
          }
          res.data.response.loadingList.forEach((item, index) => {
            this.tableData.push(item);
          });
          res.data.response.boxList.forEach((item, index) => {
            this.boxNoList.push(item);
          });
          this.total = this.tableData.length;

          for (let i = 0; i < boxNoData.length; i++) {
            for (let j = 0; j < this.boxNoList.length; j++) {
              if (
                boxNoData[i].stockingBoxListID ===
                this.boxNoList[j].stockingBoxListID
              ) {
                this.boxNoList[j].boxStatus =
                  boxNoData[i].statusBool === true ? 10 : 20;
              }
            }
          }

        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    onAddSubmit() {
      let _this = this;
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          let para = Object.assign({}, this.addForm);
          if (this.tableData.length == 0) {
            _this.$message({
              message: "请选择出库单明细数据",
              type: "error",
            });
            return;
          }

          para.DeliveryOrderList = _this.tableData;
          if (para.transportType != "海运") {
            para.containerNumber = "";
            para.sealNumber = "";
            para.soNumber = "";
            para.cabinetType = "";
          }
          if (para.carNumber != null && para.carNumber != "") {
            let regcarNumber =
              /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$/;
            if (!regcarNumber.test(para.carNumber)) {
              _this.$message({
                message: "请输入正确的车牌号，正确格式为（京A88888）",
                type: "error",
              });
              return false;
            }
          }

          _this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              var user = JSON.parse(window.localStorage.user);
              if (!user && user.id == 0) {
                _this.$message({
                  message: "用户信息为空，先登录",
                  type: "error",
                });
                _this.$router.replace(
                  _this.$route.query.redirect
                    ? _this.$route.query.redirect
                    : "/"
                );
              }

              _this.addLoading = true;

              addTFOuntboundOrder(para).then((res) => {
                _this.addLoading = false;
                if (res.data.success) {
                  _this.$refs["addRuleForm"].resetFields();
                  _this.tableData = [];
                  _this.total = 0;
                  _this.$alert(
                    "出库单号：" + res.data.msg + "，",
                    "提交成功",
                    {
                      confirmButtonText: "确定",
                      callback: (action) => {
                        window.parent.postMessage("close", "*");
                      },
                    }
                  );
                } else {
                  _this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    onGetLoadCarInfoById(tfOutboundID) {
      if (tfOutboundID == 0 || tfOutboundID == undefined) {
        this.$message({
          message: "出库单ID错误",
          type: "error",
        });
        return;
      }
      let pata = {
        tfOutboundID: tfOutboundID,
      };
      getOutboundInfoByID(pata).then((res) => {
        if (res.data.success) {
          var details = res.data.response;
           this.$set(this.addForm, "tfOutboundID", details.tfOutboundID);
           this.$set(this.addForm, "orgID", details.orgID);
           this.$set(this.addForm, "orgOutboundNo", details.orgOutboundNo);
           this.$set(this.addForm, "transportType", details.transportType);
           this.$set(this.addForm, "outWarehouseCode", details.outWarehouseCode);
           this.$set(this.addForm, "deliveryDate", details.deliveryDate);
           this.$set(this.addForm, "containerNumber", details.containerNumber);
           this.$set(this.addForm, "soNumber", details.soNumber);
           this.$set(this.addForm, "carNumber", details.carNumber);
           this.$set(this.addForm, "driver", details.driver);
           this.$set(this.addForm, "driverPhone", details.driverPhone);
          this.GetContainerNumber();

          res.data.response.deliveryOrderList.forEach((item, index) => {
            this.tableData.push(item);
          });
          this.total = this.tableData.length;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },

    getWarebaselist() {
      let user = JSON.parse(window.localStorage.user);
      console.log(user.warehouseList);
      this.WareHouse = user.warehouseList.filter((m) => {
        return m.operateType === 0;
      });
    },
    showAddDialog() {
      var orgId = this.addForm.orgID;
      if (orgId == "" || orgId == null) {
        this.$message({
          message: "请选择客户",
          type: "error",
        });
        return;
      }
      this.addDialogVisible = true;
    },
    addDialogCancel() {
      this.addDialogVisible = false;
      this.addDialogForm.orgCustomerNo = '';
    },
    addDialogSubmit() {
      let orgCustomerNo = this.addDialogForm.orgCustomerNo;
      if (orgCustomerNo == "" || orgCustomerNo == null) {
        this.$message({
          message: "请输入参考单号",
          type: "error",
        });
        return;
      }
      let isExist = this.tableData.some(item => item.orgCustomerNo === orgCustomerNo);
      if (isExist) {
        this.$message({
          message: "该参考单号已存在",
          type: "error",
        });
        return;
      }
      let para = {
        tfOutboundID:this.addForm.tfOutboundID|| 0,
        orgId: this.addForm.orgID,
        orgCustomerNo: orgCustomerNo
      };
      addTFOutDeliveryOrder(para).then((res) => {
        if (res.data.success) {
          let newList = res.data.response;
          if (newList && newList.length > 0) {
            this.tableData = [...newList, ...this.tableData];
            this.total = this.tableData.length;
          }
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.addDialogVisible = false;
          this.addDialogForm.orgCustomerNo = '';
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    getSholeStocking(stockingTaskID) {
      let pata = {
        stockingTaskID: stockingTaskID,
      };
      getSholeStockingBoxSum(pata).then((res) => {
        if (res.data.success) {
          res.data.response.loadingList.forEach((item, index) => {
            this.tableData.push(item);
          });
          res.data.response.boxList.forEach((item, index) => {
            this.boxNoList.push(item);
          });
          this.total = this.tableData.length;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
  },
  mounted() {
    this.getWarebaselist();
    let user = JSON.parse(window.localStorage.user);
    this.organizationList= user.organizationList;
    getReadyforTaskBasis("").then((res) => {
      this.transportList = res.data.response.transportdata;
      this.CabinetTypeList = res.data.response.cabinetTypeList;
    });

    var query = this.$route.query;
    console.log("dd", query.loadCarInfoID);
    if (query.tfOutboundID != undefined) {
      this.editdisbled = true;

      this.onGetLoadCarInfoById(query.tfOutboundID, query.type);
    }
    if (query.stockingTaskIDS != undefined) {
      this.addForm.outWarehouseCode = parseInt(query.wareHouseId);
      this.addForm.transportType = query.transportType;
      this.GetContainerNumber();
      this.$nextTick(function () {
        this.getSholeStocking(query.stockingTaskIDS);
      });
    }
  },
};
</script>
<style>
/* 调整对话框内容区域的padding和margin */
.el-dialog__body {
  padding: 10px 15px;
  margin-bottom: 5px;
}



.otherTable .col-bg {
  background: #fff7e6;
}
</style>
